/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — template DNA differs per sample, so it is added to each tube separately after dispensing the shared master mix.`)
};

const es_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — el ADN molde difiere en cada muestra, así que se añade a cada tubo por separado después de dispensar el master mix compartido.`)
};

const de_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein — die Template-DNA unterscheidet sich je Probe und wird deshalb nach dem Dispensieren des gemeinsamen Mastermixes separat in jedes Röhrchen gegeben.`)
};

const nl_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee — template-DNA verschilt per monster en wordt daarom apart aan elk buisje toegevoegd nadat de gedeelde mastermix is afgegeven.`)
};

const fr_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non — l'ADN matrice diffère selon l'échantillon, il est donc ajouté séparément à chaque tube après distribution du mix maître partagé.`)
};

const it_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No — il DNA template varia per campione, quindi va aggiunto separatamente a ogni provetta dopo aver distribuito il master mix condiviso.`)
};

const pt_br2_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — o DNA molde varia entre amostras, então é adicionado a cada tubo separadamente, depois de distribuído o master mix compartilhado.`)
};

const pt_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não — o ADN molde difere entre amostras, pelo que é adicionado a cada tubo separadamente, após a distribuição da master mix partilhada.`)
};

const ja_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含まれません。テンプレートDNAは試料ごとに異なるため、共有のマスターミックスを分注した後、各チューブに個別に加えます。`)
};

const zh_pcr_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不包含——模板 DNA 因样品而异，需在分装共用混合液后再单独加入每管。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_a3", locale)
	if (locale === "en") return en_pcr_faq_a3(inputs)
	if (locale === "es") return es_pcr_faq_a3(inputs)
	if (locale === "de") return de_pcr_faq_a3(inputs)
	if (locale === "nl") return nl_pcr_faq_a3(inputs)
	if (locale === "fr") return fr_pcr_faq_a3(inputs)
	if (locale === "it") return it_pcr_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_a3(inputs)
	if (locale === "pt") return pt_pcr_faq_a3(inputs)
	if (locale === "ja") return ja_pcr_faq_a3(inputs)
	return zh_pcr_faq_a3(inputs)
};